module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-tablet-es.54552c4b.webp";